export default {
    /**
     * localStorage不支持时存储数据的对象
     */
    _store: {},
    /**
     * 设置 localStorage
     * @param expire 有效时间，单位毫秒，可选, 不设置时认为永不过期
     */
    setItem: function(key, value, expire){
        this.removeItem(key);
        var _time = new Date().getTime();
        var res = {
            _value: value
        }
        // expire存在才给赋值
        expire && (res._expire = _time + expire);
        // 存储到_store属性中
        if(this.isSupportLocalStorage) {
            localStorage.setItem(key, JSON.stringify(res));
            this._store[key] = JSON.stringify(res);
        } else {
            this._store[key] = JSON.stringify(res);
        }
        return res;
    },
    /**
     * 获取某个 localStorage 值
     */
    getItem: function(key) {
        // 不支持localStorage时，从_store属性中读取
        var value = this.isSupportLocalStorage ? JSON.parse(localStorage.getItem(key)) : (this._store[key] && JSON.parse(this._store[key])),
            now = new Date().getTime();
        if(!value){
            // 不存在就返回null
            return null;
        }
        if(value._expire) {
            // 如果过期就返回null
            if(now > value._expire){
                this.removeItem(key)
                return null
            }else{
                return value._value;
            }
        } else {
            // _expire不存在视为永不过期
            return value._value;
        }
    },
    /**
     * 移除某个 localStorage 值
     */
    removeItem: function(key) {
        localStorage.removeItem(key);
    },
    /**
     * 检测是否支持window.localStorage
     */
    isSupportLocalStorage: (function() {
        var key = 'isSupportLocalStorage';
        var localStorage;

        try {
            // 当客户端禁用localStorage，访问时会报“Uncaught SecurityError”权限异常
            localStorage = window.localStorage;
        } catch (e) {
            localStorage = null;
            console.log(e);
            return false;
        }
        if (!!localStorage) {
            // ios Safari无痕模式下调用localStorage.setItem/removeItem会报错"QuotaExceededError"，需主动捕获
            try {
                localStorage.setItem(key, key);
                localStorage.removeItem(key);
                return true;
            } catch (e) {
                return false;
            }
        }
        return false;
    }())
};

export const localStorageKey = {
    browseHistory: 'articleBrowseHistory', // 记录文章离线浏览历史
    sevenDaysBrowseHistory: 'sevenDaysBrowseHistory', // 记录离线浏览历史，周期为七天，用于未登录浏览历史功能提示条
    onlineBrowseHistory: 'onlineArticleBrowseHistory', // 记录登录用户在线浏览历史
    browseHistoryRemindNum: 'browseHistoryRemindNum' // 记录浏览历史功能提示条提醒次数
}